import http from "./httpService";
import api from "../config.json";

export function getDamageTypes() {
  return http.get(api.apiUrl + "/Damage/getDamageTypes");
}

export function getMajorPests(filter) {
  return http.post(api.apiUrl + "/Pest/getMajorPests", filter);
}

export function GetConfigurationList(filter) {
  return http.post(api.apiUrl + "/PestSummary/GetConfigurationList", filter);
}

export function getMajorPestInfo(filter) {
  return http.post(api.apiUrl + "/Pest/getMajorPestInfo", filter);
}

export function getAllYears() {
  return http.get(api.apiUrl + "/PestSummary/getAllYears");
}
export function getAllYearsRpt() {
  return http.get(api.apiUrl + "/PestSummary/getAllYearsRpt");
}
export function getPestSummaryYears() {
  return http.get(api.apiUrl + "/PestSummary/getPestSummaryYears");
}

export function getAllstates() {
  return http.get(api.apiUrl + "/PestSummary/getAllstates");
}

export function getAllregions() {
  return http.get(api.apiUrl + "/PestSummary/getAllregions");
}

export function getDataForByStateTable(filter) {
  return http.post(api.apiUrl + "/PestSummary/getPestSummaryByState", filter);
}

export function getPestSummaryByRegion(filter) {
  return http.post(api.apiUrl + "/PestSummary/getPestSummaryByRegion", filter);
}

export function getPestSummaryByCounty(filter) {
  return http.post(api.apiUrl + "/PestSummary/getPestSummaryByCounty", filter);
}

export function getPestSummaryByPest(filter) {
  return http.post(api.apiUrl + "/PestSummary/getPestSummaryByPest", filter);
}

export function getPestSummarySurveyedAcres(filter) {
  return http.post(
    api.apiUrl + "/PestSummary/getPestSummarySurveyedAcres",
    filter
  );
}

export function getPestSummaryByAcres(filter) {
  return http.post(api.apiUrl + "/PestSummary/getPestSummaryByAcres", filter);
}

export function getPestSummaryMortalityAcres(filter) {
  return http.post(
    api.apiUrl + "/PestSummary/getPestSummaryMortalityAcres",
    filter
  );
}

export function getPestSummaryOtherAcres(filter) {
  return http.post(
    api.apiUrl + "/PestSummary/getPestSummaryOtherAcres",
    filter
  );
}

export function getPestSummaryDamageAcres(filter) {
  return http.post(
    api.apiUrl + "/PestSummary/getPestSummaryDamageAcres",
    filter
  );
}

export function getPestSummaryDamageCounty(filter) {
  return http.post(
    api.apiUrl + "/PestSummary/getPestSummaryDamageCounty",
    filter
  );
}
